const getters = {
  homeInfo: state => state.home.homeInfo,
  buttonCfg: state => state.home.buttonCfg,
  projectVersion: state => state.home.projectVersion,
  verificationDialogVisible: state => state.home.verificationDialogVisible,
  verificationOnce: state => state.home.verificationOnce,
  shareInfo: state => state.home.shareInfo,
  HospitalLogo: state => state.home.HospitalLogo,
  encryptionEnabledFlag: state => state.home.encryptionEnabledFlag,
  patientPhone: state => state.home.patientPhone,

  
  imageBrowsing: state => state.imageBrowsing.seriesDataList,
  imageBrowsingViewportList: state => state.imageBrowsing.viewportList,
  electronicFilm: state => state.electronicFilm.seriesDataList,
  historyData:state => state.historyCheck.historyData,
  pdfData:state => state.imageAndText.pdfData,
  imageTiaoChuang:state => state.imageBrowsing.imageTiaoChuang,
  useMPR:state => state.imageBrowsing.useMPR,
  fourCornerMarkDataParse:state => state.imageBrowsing.fourCornerMarkDataParse,
  errorInfo:state => state.imageBrowsing.errorInfo,


}
export default getters
